/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { store } from 'redux/store';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import WizardSteps from '../wizard-steps';
import SearchTabList from '../search-tab-list';

const AddNewEquipment = ({ asset = false, setActive, setAddNew }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [step, setStep] = useState(0);
  const [assetKind, setAssetKind] = useState('Site');
  const [checkFormName, setCheckFormName] = useState();
  const [equipment, setEquipment] = useState(null);
  const [idOf, setIdOf] = useState('');
  const pathname = location.pathname;

  const steps = [
    {
      title: `Find and select the ${assetKind.toLowerCase()}.`,
      content: (
        <SearchTabList
          label={assetKind}
          onSelect={(id) => {
            setAddNew('');
            setActive(false);
            setTimeout(() => {
              navigate(`/add-edit-equipment?new-equipmentId=${uuidv4()}&siteId=${id}`);
            }, 0);
          }}
        />
      )
    },
    {
      title: 'New Check Added Successfully.',
      content: ''
    }
  ];

  const onClickStep = (step) => {
    setStep(step);
  };

  return (
    <div>
      <WizardSteps
        current={1}
        setStep={onClickStep}
        total={1}
        title={steps[step].title}
        content={steps[step].content}
        breadcrumbs={
          [assetKind]
          // asset
          //   ? [checkFormName?.toString() || 'Check type']
          //   : [
          //       assetKind || 'Asset type',
          //       checkFormName?.toString() || 'Check type',
          //       equipment?.name || `Select ${assetKind}`,
          //       'Added'
          //     ]
        }
      />
    </div>
  );
};

export default AddNewEquipment;
